import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/i18n/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import EdgeOnePage from "@/pages/EdgeOnePage";
import UseCasePage from "@/pages/UseCasePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <Toaster position="top-right" richColors closeButton />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/products/edgeone" element={<EdgeOnePage />} />
              <Route path="/use-cases/:slug" element={<UseCasePage />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
